import { createAction, props } from "@ngrx/store";
import { CheckData } from "../models/check/CheckData";
import { ServiceError, ServiceErrorWithList } from "../models/shared/ServiceError";
import { StandingAuthInputRequest } from "../models/check/CheckInputRequest";
import { StandingInstruction } from "../../shared/types/StandingInstruction";
import { CashieringTransaction, RecurringTransaction } from "../models";
import { transactionTypes, ViewTypes } from "../../shared/utilities/Constants";
import { CheckInquiryResponse } from "../models/check/CheckInquiryResponse";

export const callOneTimeInput = createAction(
    '[Create Transaction - Check] Call to Onetime Check Input'
)

export const callOneTimeInputSilent = createAction(
    '[Create Transaction - Check] Call to Onetime Check Input (Silent - No Reducer Updates)'
)

export const callRecurringInput = createAction(
    '[Create Transaction - Check] Call to Recurring Check Input'
)

export const inputCallSuccessful = createAction(
    '[Create Transaction - Check] Call to Check Input succeeded',
    props<{ checkInputResponse: CheckData }>()
)

export const inputCallSuccessfulSilent = createAction(
    '[Create Transaction - Check] Call to Check Input succeeded (Silent - Minimal Updates)',
    props<{ checkInputResponse: CheckData }>()
)

export const inputCallFailed = createAction(
    '[Create Transaction - Check] Call to Check Input failed',
    props<ServiceError>()
)

export const verifyCallSuccessful = createAction(
    '[Create Transaction - Check] Call to Check Verify succeeded',
    props<{ checkVerifyResponse: CheckData }>()
)

export const verifyCallFailed = createAction(
    '[Create Transaction - Check] Call to Check Verify Failed',
    props<ServiceErrorWithList>()
)

export const callOnetimeAcknowledge = createAction(
    '[Create Request - Check] Call to Onetime Check acknowledge'
);

export const callRecurringAcknowledge = createAction(
    '[Create Request - Check] Call to Recurring Check acknowledge'
);

export const acknowledgeCallSuccessful = createAction(
    '[Create Transaction - Check] Call to Check Acknowledge succeeded',
    props<{ checkAcknowledgeResponse: CheckData }>()
)

export const acknowledgeCallFailed = createAction(
    '[Create Transaction - Check] Call to Check Acknowledge failed',
    props<ServiceErrorWithList>()
)

export const extraPromptsChanged = createAction(
    '[Create Transaction - Check] Extra prompts changed'
);

export const standingAuthSelected = createAction(
    '[Create Request - Check] Standing Auth Selected',
    props<{ payload: StandingAuthInputRequest }>()
);

export const inputCallFinishedWithError = createAction(
    '[Create Request - Check] Input call finished with error',
    props<{ checkInputResponse: CheckData }>()
);

export const verifyCallFinishedWithError = createAction(
    '[Create Request - Check] Verify call finished with error',
    props<{ checkVerifyResponse: CheckData }>()
);

export const callInquiry = createAction(
    '[Create Request - Check] Call to Check inquiry',
    props<{ payload: StandingInstruction | CashieringTransaction | RecurringTransaction, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const inquiryCallSuccessful = createAction(
    '[Create Request - Check] Call to Check Inquiry was successful',
    props<{ checkInquiryResponse: CheckInquiryResponse }>()
);

export const incomingInquiryCallSuccessful = createAction(
    '[Create Request - Check] Call to Incoming Check Inquiry was successful',
    props<{ checkInquiryResponse: CheckInquiryResponse }>()
);

export const inquiryCallFailed = createAction(
    '[Create Request - Check] Call to Check Inquiry failed',
    props<ServiceError>()
);

export const nsfClientSideError = createAction(
    '[Create Request - Check] Dig2Pdf sufficient funds check failed'
);


